import { render, staticRenderFns } from "./PaymentOrderPartnersSideForm.vue?vue&type=template&id=948731a6&scoped=true&"
import script from "./PaymentOrderPartnersSideForm.vue?vue&type=script&lang=js&"
export * from "./PaymentOrderPartnersSideForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948731a6",
  null
  
)

export default component.exports